import React from 'react';
import PropTypes from 'prop-types';
import { Box, Tabs } from '@zillow/constellation';
import AmortizationFields from './AmortizationFields.js';
import { FieldConfig, TERM_TO_RATE, RFC_2822_MONTHS, DEFAULT_VALUES_SHAPE } from './AmortizationCalculator.utils.js';
export { DEFAULT_VALUES_SHAPE } from './AmortizationCalculator.utils.js';
import { LOAN_PROGRAMS } from '../../utils/zhl-calculator.js';
import { omitUndefined } from '../../utils/lodash.js';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import AmortizationPaymentSummary from './AmortizationPaymentSummary.js';
import AmortizationLineChart from './AmortizationLineChart.js';
import AmortizationScheduleTable from './AmortizationScheduleTable.js';
import { handleFieldClickEvent } from './AmortizationCalculator.Clickstream.js';

var AmortizationCalculator = function AmortizationCalculator(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues,
    editorMode = _ref.editorMode;
  var finalDefaultValues = Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.amount.name] = 200000, _Object$assign[FieldConfig.term.name] = LOAN_PROGRAMS.fixed30Year, _Object$assign[FieldConfig.rate.name] = TERM_TO_RATE.Fixed30Year.rate, _Object$assign[FieldConfig.startMonth.name] = RFC_2822_MONTHS[new Date().getMonth()], _Object$assign[FieldConfig.startYear.name] = new Date().getFullYear(), _Object$assign), omitUndefined(defaultValues));
  return /*#__PURE__*/React.createElement(CalculatorForm, {
    fieldStorageKey: "amortizationfields",
    defaultValues: finalDefaultValues,
    editorMode: editorMode
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      paddingBottom: '$spacing.sm',
      display: 'flex',
      flexDirection: 'column-reverse',
      '@media $lg': {
        'flex-direction': 'row',
        'justify-content': 'space-between'
      }
    }
  }, /*#__PURE__*/React.createElement(AmortizationFields, null), /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'sticky',
      top: '0',
      alignSelf: 'flex-start',
      '@media $md': {
        'flex-basis': '65%'
      }
    }
  }, /*#__PURE__*/React.createElement(Tabs, {
    defaultSelected: "payment-tab"
  }, /*#__PURE__*/React.createElement(Tabs.List, {
    "aria-label": "Default tabs example"
  }, /*#__PURE__*/React.createElement(Tabs.Tab, {
    id: "payment-tab",
    "aria-controls": "payment-panel",
    type: "button",
    onClick: function onClick() {
      return handleFieldClickEvent('Payment', 'tab');
    }
  }, "Payment"), /*#__PURE__*/React.createElement(Tabs.Tab, {
    id: "chart-tab",
    "aria-controls": "chart-panel",
    type: "button",
    onClick: function onClick() {
      return handleFieldClickEvent('Chart', 'tab');
    }
  }, "Chart"), /*#__PURE__*/React.createElement(Tabs.Tab, {
    id: "schedule-tab",
    "aria-controls": "schedule-panel",
    type: "button",
    onClick: function onClick() {
      return handleFieldClickEvent('Schedule', 'tab');
    }
  }, "Schedule")), /*#__PURE__*/React.createElement(Tabs.Panels, null, /*#__PURE__*/React.createElement(Tabs.Panel, {
    id: "payment-panel",
    "aria-labelledby": "payment-tab"
  }, /*#__PURE__*/React.createElement(AmortizationPaymentSummary, null)), /*#__PURE__*/React.createElement(Tabs.Panel, {
    id: "chart-panel",
    "aria-labelledby": "chart-tab"
  }, /*#__PURE__*/React.createElement(AmortizationLineChart, null)), /*#__PURE__*/React.createElement(Tabs.Panel, {
    id: "schedule-panel",
    "aria-labelledby": "schedule-tab"
  }, /*#__PURE__*/React.createElement(AmortizationScheduleTable, null)))))));
};
AmortizationCalculator.defaultProps = {
  defaultValues: undefined,
  editorMode: undefined
};
AmortizationCalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  defaultValues: PropTypes.shape(DEFAULT_VALUES_SHAPE),
  editorMode: PropTypes.bool
} : {};
var AmortizationCalculator$1 = AmortizationCalculator;

export { AmortizationCalculator$1 as default };
